"use client"

import { ChevronLeft, ChevronRight } from 'lucide-react'

const btnBase =
	'inline-flex items-center justify-center gap-1 min-w-9 h-9 px-3 text-sm font-semibold rounded-lg border transition-colors disabled:opacity-40 disabled:cursor-not-allowed'

export default function Pagination({ currentPage = 1, totalPages = 1, onPageChange }) {
	if (totalPages <= 1) return null

	const getPages = () => {
		const pages = []
		if (totalPages <= 5) {
			for (let i = 1; i <= totalPages; i++) pages.push(i)
			return pages
		}
		if (currentPage <= 3) {
			pages.push(1, 2, 3, 4, '...', totalPages)
		} else if (currentPage >= totalPages - 2) {
			pages.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages)
		} else {
			pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages)
		}
		return pages
	}

	return (
		<nav className="flex flex-wrap items-center justify-center gap-1.5" aria-label="Pagination">
			<button
				type="button"
				className={`${btnBase} border-(--border-default) bg-white text-(--text-primary) hover:border-(--brand-primary) hover:text-(--brand-primary)`}
				disabled={currentPage === 1}
				onClick={() => onPageChange(currentPage - 1)}
			>
				<ChevronLeft size={16} />
				<span className="hidden sm:inline">मागे</span>
			</button>

			{getPages().map((page, index) =>
				page === '...' ? (
					<span
						key={`ellipsis-${index}`}
						className="inline-flex items-center justify-center min-w-9 h-9 text-(--text-tertiary)"
					>
						…
					</span>
				) : (
					<button
						key={page}
						type="button"
						onClick={() => onPageChange(page)}
						className={`${btnBase} ${
							currentPage === page
								? 'border-(--brand-primary) bg-(--brand-primary) text-white'
								: 'border-(--border-default) bg-white text-(--text-primary) hover:border-(--brand-primary) hover:text-(--brand-primary)'
						}`}
						aria-current={currentPage === page ? 'page' : undefined}
					>
						{page}
					</button>
				)
			)}

			<button
				type="button"
				className={`${btnBase} border-(--border-default) bg-white text-(--text-primary) hover:border-(--brand-primary) hover:text-(--brand-primary)`}
				disabled={currentPage === totalPages}
				onClick={() => onPageChange(currentPage + 1)}
			>
				<span className="hidden sm:inline">पुढे</span>
				<ChevronRight size={16} />
			</button>
		</nav>
	)
}
